"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_INIT_MODE = exports.INIT_COMPONENT = void 0;
var prefix = '@@react-redux-component-init/';
/**
 * Action type for switching the initMode of the module. See `initMode`
 * @type {string}
 */

var SET_INIT_MODE = "".concat(prefix, "SET_INIT_MODE");
/**
 * Action type for initializing a component. Is used both when a component initializes
 * itself, as when a component is prepared using `prepareComponent()`
 * @type {string}
 */

exports.SET_INIT_MODE = SET_INIT_MODE;
var INIT_COMPONENT = "".concat(prefix, "INIT_COMPONENT");
exports.INIT_COMPONENT = INIT_COMPONENT;